export default "__VITE_ASSET__i9D9REdt__"